export function getCalculatedCarouselTranslateX(
  currentIndex: number,
  centerPadding = '0px'
) {
  const defaultTranslateX = `-${currentIndex * 100}%`;
  // centerPadding 수치만큼 실제 Carousel Item 크기가 작아지므로, 그 영향을 받는 만큼 translateX에서 제외해야함
  const centerPaddingTranslateX = `calc(${centerPadding} * ${
    currentIndex * 2 + 1
  })`;
  return `calc(${defaultTranslateX} + ${centerPaddingTranslateX})`;
}
